import React, { FC, ReactElement, useState } from 'react'
import Typography from '@material-ui/core/Typography'
import { getStyles } from 'isotope-client'
import { withStyles } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import { colors } from '../../utils/constants'

const styles = () => getStyles({
	title: {
		color: colors.primary,
		fontWeight: 'bold' as 'bold',
		fontSize: 12,
		cursor: 'pointer'
	},
	toggle: {
		color: colors.primary,
		display: 'flex',
		alignItems: 'center' as 'center',
		marginBottom: 6,
		marginTop: 12,
		marginLeft: '-8px'
	},
	iconRotate: {
		fontSize: '2rem !important',
		transform: 'rotate(90deg)',
		transition: 'ease-in-out 0.1s',
		cursor: 'pointer'
	},
	icon: {
		transform: 'rotate(0)'
	},
	body: {
		marginTop: 6,
		fontSize: 12
	}
})

type CollapsableSectionProps = {
	title: ReactElement
	body: ReactElement
	defaultCollapsed?: boolean
	classes: ClassNameMap
}

const CollapsableSection: FC<CollapsableSectionProps> = ({ title, body, defaultCollapsed = false, classes }) => {
	const [collapsed, setCollapsed] = useState<boolean>(defaultCollapsed)

	return <>
		<div onClick={() => setCollapsed(state => !state)} className={classes.toggle}>
			<ArrowRightIcon className={`${classes.iconRotate} ${collapsed ? '' : classes.icon}`} />
			<Typography variant="body1" className={classes.title}>{title}</Typography>
		</div>
		{collapsed && <div className={classes.body}>
			{body}
		</div>
		}
	</>

}

export default withStyles(styles)(CollapsableSection)